'use client'
import { useState, memo } from 'react'
import { Drawer, Box, List, ListItem, ListItemText } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import Link from 'next/link'
import { Tel, MainButton } from '@/components/Inputs'
import { resolveHref } from '@/utilites/resolveHref'

interface MenuLink {
    label: string
    url: string
}

interface MenuClientProps {
    menuLinks: MenuLink[]
    tel?: string
    button?: { link?: string; text?: string }
    color?: string
    display?: string | { [key: string]: string }
}

const MenuClient = ({ menuLinks, tel, button, color, display={ xs: 'block', md: 'none'} }: MenuClientProps) => {
    const [open, setOpen] = useState(false)
    return (
        <>
            <Box
                onClick={() => setOpen(true)}
                aria-label='open menu'
                role='button'
                sx={{ color: color || 'inherit', display: display, cursor: 'pointer', lineHeight: 0 }}
            >
                <MenuIcon fontSize='medium' />
            </Box>

            <Drawer
                anchor='right'
                open={open}
                onClose={() => setOpen(false)}
                slotProps={{ paper: { sx: { backgroundColor: 'white' } } }}
            >
                <Box
                    role='presentation'
                    sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}
                    onClick={() => setOpen(false)}
                >
                    <MainButton button={button} />
                    {tel && <Tel tel={tel} />}

                    <List sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {menuLinks.map(({ label, url }) => (
                            <ListItem
                                key={label}
                                disablePadding
                            >
                                <Link
                                    href={resolveHref(url)}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'black',
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        fontFamily: 'MonaSansCondensed, sans-serif',
                                    }}
                                >
                                    <ListItemText primary={label} />
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    )
}

export default memo(MenuClient)


